import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// MSAL imports
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

ReactDOM.render(
	// <React.StrictMode>
		<App pca={msalInstance} baseUrl={baseUrl} />,
	// </React.StrictMode>,
	document.getElementById('root')
);
